import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { NotificationCollection } from '../pathways-ui/models/notification-collection.model';

@Injectable({
	providedIn: 'root',
})
export class NotificationService {
	notificationController = '/api/notification';

	constructor(private _http: HttpClient) {}

	getNotifications(): Observable<NotificationCollection[]> {
		return this._http
			.get<NotificationCollection[]>(
				`${this.notificationController}/GetNotifications`
			)
			.pipe(map((data) => data));
	}

	markAsRead(notificationId: number): Observable<void> {
		const headers = new HttpHeaders().set('Content-Type', 'application/json');
		const body = JSON.stringify(notificationId);

		return this._http
			.put(this.notificationController + '/MarkAsRead', body, { headers })
			.pipe(map(() => {}));
	}
	markListAsRead(notificationIds: number[]): Observable<void> {
		return this._http.post<void>(
			`${this.notificationController}/MarkListAsRead`,
			notificationIds
		);
	}
}
